<template>
  <div class="kye-editor-new"
        :class="editorClass"
       :tagId="tagId"
       :style="editorStyle"
       ref="kye-editor-new">
      <div class="toolbar"
          ref="toolbar">
        <kye-upload
            style="display:none"
            ref="upload"
            :accept="uploadAccept"
            :code="bizCode"
            :show-file-list="false"
            @success="(files, list) => uploadSuccess(files, list)">
        </kye-upload>
        <template v-for="item in toolbarConfigList">
          <ToolbarFormatter v-if="item.formatter"
                            :key="item.key"
                            :option="item" />
        </template>
      </div>
    <slot> </slot>
    <div class="editor ql-editor"
         ref="editor">
    </div>

    <div class="maxlength-warp"
         v-if="maxLength">
      <span :class="fontCount > maxLength ? 'overText' : ''">{{fontCount}}</span>
      <span>/{{maxLength}}</span>
    </div>
    <kye-dialog
      v-bind="dialogOption"
      :view.sync="dialogOption.view"
      :visible.sync="dialogOption.show"
      style="min-height:160px;">
      <component
        :is="dialogOption.view"
        :bizCode="bizCode"
        :limit="uploadFileLimit"
        @setUser="setUser"
        @addLink="addLink"
        @uploadFile="uploadFileHanlder"
        @close="closeDynamicDialog">
      </component>
    </kye-dialog>
  </div>
</template>

<script>
  import { getToken } from 'public/utils'
  import { colorList, FONT_SIZE } from './conf'
  import Assign from './blot/select-user.js'
  import FileBlot from './blot/upload-file.js'
  import ImageResize from './blot/image-resize/imageResize.js'
  import { copyFormat } from './blot/format-painter'
  import SearchUser from './components/search-user.vue'
  import superLink from './components/super-link.vue'
  import UploadFile from './components/upload-file.vue'
  import ToolbarFormatter from './components/toolbar-formatter'
  import { toolsRender } from './components/tools.js'
  import EmojiBlot from './blot/emoji.js'
  import LinkBlot from './blot/link.js'
  import axios from 'axios'
  import './quill.snow.css'

  const ustr = () => Math.random().toString(36).substr(3)
  const createUuid = () => ustr() + ustr()

  export default {
    name: 'kye-editor-new',
    components: {
      SearchUser,
      UploadFile,
      ToolbarFormatter,
      superLink
    },
    data () {
      return {
        Quill: null,
        quill: null,
        editor: null,
        inputLock: true,
        compositionThen: false,
        currentRange: null,
        session_id: false,
        session_type: null,
        keyAtIng: false,
        catchPeople: [],
        onceKeyDownCount: 0,
        fontCount: 0,
        toolbarConfigList: [],
        tagId: createUuid(),
        painterConfig: {},
        dialogOption: {
          width: '1200px',
          title: '',
          show: false,
          view: '',
        },
        userSelectionIndex: 0,
        uploadAccept: null
      }
    },
    props: {
      tool: {
        type: Array,
        default () {
          return [
            'color',
            'size',
            'bold',
            'italic',
            'underline',
            'align',
            'ordered',
            'bullet',
            'indent1',
            'indent2',
            'undo',
            'redo',
          ]
        }
      },
      maxLength: {
        type: Number,
        default () {
          return 1000
        }
      },
      disabled: {
        type: Boolean,
        default () {
          return false
        }
      },
      canPasteImg: {
        type: Boolean,
        default () {
          return true
        }
      },
      defaultValue: {
        type: String,
        default () {
          return ''
        }
      },
      defaultFontSize: {
        type: [String, Number],
        default: 12
      },
      placeholder: {
        type: String,
        default: ''
      },
      bizCode: {
        type: String,
        default: 'erp_fontend_public_kye_editor_new'
      },
      uploadFileLimit: {
        type: Number,
        default: 5,
      },
      scrollingContainer: {
        type: String,
        default: null
      },
      dontPasteImgMsg: {
        type: String,
        default: '禁止粘贴图片'
      },
      // 编辑器可拖拽（'both', 'horizontal', 'vertical', 'none')
      editorResize: {
        type: String,
        default: 'none'
      }
    },
    watch: {
      disabled (val) {
        this.disabledEditor(val)
      }
    },
    created () {
      // vue框架 组件内部生成全局唯一id
      if (this._uid) {
        this.tagId = this.tagId + this._uid
      }
    },
    computed: {
      editorClass () {
        return {
          'kye-editor-new-cursor-pointer': this.painterConfig.type,
          'is-resize': this.editorResize !== 'none',
          'is-disabled': this.disabled
        }
      },
      editorStyle() {
        let style = {}
        if (this.editorResize) {
          style.overflow = 'auto'
          style.resize = this.editorResize
          style.minHeight = '120px'
          style.height = '350px'
        }
        return style
      }
    },
    mounted () {
      import(/* webpackChunkName: "public-kye-editor-new" */ './quill.js').then((E) => {
        this.Quill = E.default
        this.init()
        this.$emit('create-editor')
      })
    },
    methods: {
      init () {
        this.renderTool()
        this.addFontSize()
        this.addBlot()
        this.createEditor()
        this.$nextTick(() => {
          this.setSelectClick()
          this.setClickEvent()
          this.setCustomMatcher()
        })
        this.setMaxLength()
        this.setCountBtnFormat()
        this.setDefaultOptions()
        this.initEmojiFocusEvent()
      },
      // 将阿拉伯数字转换为罗马数字
      convertRoma (num) {
        let numArr = [1, 4, 5, 9, 10, 40, 50, 90, 100, 400, 500, 900, 1000]
        let romArr = ['i', 'iv', 'v', 'ix', 'x', 'xl', 'l', 'xc', 'c', 'cd', 'd', 'cm', 'm']
        let romStr = ''
        if (num > 0) {
          let index = numArr.length
          while (index >= 0) {
            if (num >= numArr[index]) {
              num -= numArr[index]
              romStr += romArr[index]
            } else {
              index--
            }
          }
        }
        return romStr
      },
      // 将阿拉伯数字转换为字母
      convert26 (num) {
        let str = ''
        while (num > 0) {
          let m = num % 26
          if (m === 0) {
            m = 26
          }
          str = String.fromCharCode(m + 96) + str
          num = (num - m) / 26
        }
        return str
      },
      // 将rgb色值转换为HEX色值
      rebToHex (color) {
        let reg = /^(rgb|RGB)/
        if (reg.test(color)) {
          let strHex = '#'
          let colorArr = color.replace(/(?:\(|\)|rgb|RGB)*/g, '').split(',')
          for (let i = 0; i < colorArr.length; i++) {
            let hex = Number(colorArr[i]).toString(16)
            if (hex === '0') {
              hex += hex
            }
            strHex += hex
          }
          return strHex
        } else {
          return String(color)
        }
      },
      // PC端与web端交互时，web端接收PC端文本的方法，erp可能暂时用不上
      getHtmlStr (str, start, end) {
        let res = str.match(new RegExp(`${start}(.*?)${end}`))
        return res ? res[1] : null
      },
      getTextStr (str) {
        let formatStr = null
        if (str.includes(`"cmd":"getRichTextHtml",`) && str.includes(`"is_text":true,`)) {
          formatStr = str.replace(/\n/g, '\\n').replace(/\t/g, '\\t').replace(/'/g, '\'')
        }
        return formatStr
      },
      formatRes (res) {
        let htmlStr = this.getHtmlStr(res, `"html":"`, `","is_at_high_lighted":`) || this.getHtmlStr(res, `"html":"`, `","session_id":"`)
        let textFormatStr = this.getTextStr(res)
        let obj
        if (htmlStr) {
          obj = JSON.parse(res.replace(htmlStr, ''))
          obj.data.html = htmlStr
        } else if (textFormatStr) {
          obj = JSON.parse(textFormatStr)
          obj.data.text = obj.data.text.replace(/\[#替换用特殊单引号#]/g, "'")
        } else {
          obj = JSON.parse(res)
        }
        return obj
      },
      // 计算工具栏的高亮状态
      countBtnFormat () {
        if (!this.inputLock || this.compositionThen) {
          return false
        }
        // 获取用户设置的配置
        /**
         * 获取用户编辑光标位置，并传入getFormat
         * 处理原因：如果不传，getFormat内部会调用getSelection方法，该方法会自动将滚动条定位到编辑器。
         */
        let range = this.quill.selection.savedRange
        let formatData = this.quill.getFormat(range)
        let size = this.$refs['kye-editor-new'].querySelector(`[action="size"]`)
        let bold = this.$refs['kye-editor-new'].querySelector(`[action="bold"]`)
        let italic = this.$refs['kye-editor-new'].querySelector(`[action="italic"]`)
        let underline = this.$refs['kye-editor-new'].querySelector(`[action="underline"]`)
        let deleteline = this.$refs['kye-editor-new'].querySelector(`[action="deleteline"]`)
        let ordered = this.$refs['kye-editor-new'].querySelector(`[action="ordered"]`)
        let bullet = this.$refs['kye-editor-new'].querySelector(`[action="bullet"]`)
        let indent2 = this.$refs['kye-editor-new'].querySelector(`[action="indent2"]`)
        let indent1 = this.$refs['kye-editor-new'].querySelector(`[action="indent1"]`)
        let painter = this.$refs['kye-editor-new'].querySelector(`[action="painter"]`)
        const align = this.$refs['kye-editor-new'].querySelector('.align-btn .tool-icon-value')
        bold && (bold.className = !formatData.bold ? 'our-btn' : 'our-btn check')
        italic && (italic.className = !formatData.italic ? 'our-btn' : 'our-btn check')
        underline && (underline.className = !formatData.underline ? 'our-btn' : 'our-btn check')
        deleteline && (deleteline.className = !formatData.strike ? 'our-btn' : 'our-btn check')
        ordered && (ordered.className = formatData.list !== 'ordered' ? 'our-btn' : 'our-btn check')
        bullet && (bullet.className = formatData.list !== 'bullet' ? 'our-btn' : 'our-btn check')

        if (this.painterConfig.type) {
          painter && (painter.className = 'our-btn check')
        } else {
          painter && (painter.className = 'our-btn')
        }

        if (align) {
          if (formatData.align === 'center') {
            align.className = 'tool-icon tool-icon-value icon-youduiqi'
          } else if (formatData.align === 'right') {
            align.className = 'tool-icon tool-icon-value icon-juzhong'
          } else {
            align.className = 'tool-icon tool-icon-value icon-zuoduiqi'
          }
        }

        if (indent2) {
          if (formatData.indent) {
            indent2.classList.remove('disabled')
          } else {
            indent2.classList.add('disabled')
          }
        }
        if (indent1) {
          if (formatData.indent > 5) {
            indent1.classList.add('disabled')
          } else {
            indent1.classList.remove('disabled')
          }
        }

        if (size) {
          if (formatData.size) {
            size.querySelector('.font-size').innerHTML = formatData.size.replace('px', '')
          } else {
            size.querySelector('.font-size').innerHTML = parseInt(this.defaultFontSize)
          }
        }

        if (painter) {
        }

        this.upTextCount()
      },
      // 往上查找直到button标签
      getBtn (node) {
        while (node && node.tagName !== 'BUTTON') {
          node = node.parentNode
        }
        return node
      },
      // 查找节点的父元素
      findNodeParent (node, name) {
        let el = node
        while (el && el.parentNode && !el.className.includes(name)) {
          el = el.parentNode
        }
        return el
      },
      getAtList (html) {
        let list = []
        let count = 0
        function mapNodeChild (node) {
          node.childNodes.forEach((el, index) => {
            if (el.tagName === 'SPAN' && el.parentNode.tagName === 'AT') {
              let length = el.innerText.length
              let lengthDeviation = 1
              let locationDeviation = 0
              list.push({
                location: count - locationDeviation,
                length: length - lengthDeviation,
                uid: el.parentNode.id
              })
              count += length
            } else if (el.hasChildNodes()) {
              if ((el.tagName === 'P' || el.tagName === 'LI' || el.tagName === 'UL' || el.tagName === 'OL') && count !== 0 && node.childNodes[index - 1]) {
                count += 1
              }
              mapNodeChild(el)
            } else if ((node.childNodes[index + 1] && node.childNodes[index + 1].tagName === 'SPAN' && node.childNodes[index + 1].getAttribute('contenteditable') === 'false') || (node.childNodes[index - 1] && node.childNodes[index - 1].tagName === 'SPAN' && node.childNodes[index - 1].getAttribute('contenteditable') === 'false')) {
            } else {
              count += el.length || 0
            }
          })
        }
        if (html) {
          let copyNode = document.createElement('DIV')
          copyNode.innerHTML = html
          mapNodeChild(copyNode)
        } else {
          mapNodeChild(this.$refs['kye-editor-new'].querySelector('.ql-editor'))
        }
        return list
      },
      // 计算文本长度
      upTextCount () {
        setTimeout(() => {
          if (!this.getNativeText().trim().length) {
            this.fontCount = 0
          } else {
            this.fontCount = this.quill.getLength() - 1
          }
        }, 0)
      },
      // 重置富文本内容，清空历史
      resetContent (content) {
        this.setContent(content)
        this.quill.history.clear()
        this.setHistoryLight()
      },
      // 会往富文本历史栈中添加历史,该操作会被工具栏的撤回按钮撤回
      setContent (content) {
        this.disabled && this.quill.enable(true)
        let delta = this.quill.clipboard.convert(content)
        this.quill.setContents(delta, 'user')
        this.disabled && this.quill.enable(false)
        // this.quill.format('list', false)
      },
      getContent () {
        return this.editor.querySelector('.ql-editor').innerHTML
      },
      // 接收getNativeHtml处理过的html文本，还原为web端的正常html文本，内嵌到跨声PC端时使用
      restoreNativeHtml (html) {
        try {
          // html = '<p><font num=\"1\">发生发生发顺丰阿萨法</font><strong><font num=\"1\">发生法发顺丰<u>发顺丰阿萨法撒发生</u></font></strong><strong><font num=\"6\"><u>发生法发顺丰阿萨法</u></font></strong><strong style=\"color: rgb(219, 117, 0);\"><font num=\"6\"><u>发生法发顺丰按时</u></font></strong></p>'
          let dom = document.createElement('div')
          dom.innerHTML = html
          dom.className = 'ql-editor'
          // 将 getNativeHtml 中的 font 标签还原为文本节点
          let fontList = dom.querySelectorAll('font')
          fontList.forEach(node => {
            let sizeMap = {
              '1': '12px',
              '2': '14px',
              '3': '16px',
              '4': '18px',
              '5': '20px',
              '6': '24px',
              '7': '28px',
            }
            let size = node.getAttribute('num')
            let fontSize = sizeMap[size]
            if (node.parentNode.tagName === 'P' && node.parentNode.parentNode.className.includes('ql-editor')) {
              let text = document.createElement('SPAN')
              text.style.setProperty('font-size', fontSize)
              text.innerHTML = node.innerHTML
              node.parentNode.replaceChild(text, node)
            } else {
              node.parentNode.style.setProperty('font-size', fontSize)
              node.parentNode.innerHTML = node.innerHTML
              // let text = document.createTextNode(node.innerHTML)
              // node.parentNode.replaceChild(text, node)
            }
          })
          // 将 getNativeHtml 中的 添加的数字序号 移除
          dom.querySelectorAll('ol').forEach(ol => {
            ol.querySelectorAll('li').forEach(node => {
              node.innerHTML = node.innerHTML.replace(/^[a-z0-9]+./, '')
            })
          })
          // 将 getNativeHtml 中的 添加的标点序号 移除
          dom.querySelectorAll('ul').forEach(ul => {
            ul.querySelectorAll('li').forEach(node => {
              node.innerHTML = node.innerHTML.replace(/^•/, '')
            })
          })
          return dom.innerHTML
        } catch (e) {
          return html
        }
      },
      // 获取可供PC客户端和APP客户端解析的html文本
      getNativeHtml () {
        let countList = [0, 0, 0, 0, 0, 0, 0, 0, 0]
        let nodeCopy = document.createElement('div')
        nodeCopy.innerHTML = this.$refs['kye-editor-new'].querySelector('.editor .ql-editor').innerHTML.replace(/&nbsp;/gm, ' ')
        nodeCopy.querySelectorAll('ol').forEach(ol => {
          ol.querySelectorAll('li').forEach(node => {
            let level = Number(node.className.replace('ql-indent-', '')) || 0
            let index
            if (level % 3 === 0) {
              index = Number(countList[level]++) + 1
            }
            if (level % 3 === 1) {
              index = this.convert26(Number(countList[level]++) + 1)
            }
            if (level % 3 === 2) {
              index = this.convertRoma(Number(countList[level]++) + 1)
            }
            node.innerHTML = `${index}.${node.innerHTML}`
            countList.splice(level + 1, 9 - (level + 1), ...new Array(9 - (level + 1)).fill(0))
          })
        })
        nodeCopy.querySelectorAll('ul').forEach(ol => {
          ol.querySelectorAll('li').forEach(node => {
            node.innerHTML = `•${node.innerHTML}`
          })
        })

        let sizeMap = {
          '12px': '1',
          '14px': '2',
          '16px': '3',
          '18px': '4',
          '20px': '5',
          '24px': '6',
          '28px': '7',
        }
        const replaceChild = (node, child) => {
          // 如果是文本节点或者没有设置过font-size值的标签，给个默认值为12像素
          if (child.nodeName === '#text') {
            if (['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(node.tagName)) {
              return
            }
            let newChild = document.createElement('font')
            newChild.setAttribute('num', '1')
            newChild.textContent = child.textContent
            node.replaceChild(newChild, child)
          } else if (child.tagName !== 'LI' && !child.style.fontSize) {
            child.innerHTML = `<font num="1">${child.innerHTML}</font>`
          }
        }
        nodeCopy.childNodes.forEach(node => {
          node.childNodes.forEach(child => {
            replaceChild(node, child)
          })
        })
        nodeCopy.querySelectorAll('li').forEach(node => {
          node.childNodes.forEach(child => {
            replaceChild(node, child)
          })
        })
        nodeCopy.querySelectorAll('[openid]').forEach(node => {
          const openId = node.getAttribute('openid')
          if (openId) {
            const parentNode = node.parentNode
            const newInnerText = node.innerText.split('\uFEFF').join('')
            const nodeHtml = `<at id="${openId}">${newInnerText}</at></font>`
            if (!parentNode.style.fontSize) {
              const newChild = document.createElement('font')
              node.innerHTML = nodeHtml
              newChild.innerHTML = `<font num="1">${node.outerHTML}</font>`
              parentNode.replaceChild(newChild, node)
            } else {
              node.innerHTML = nodeHtml
            }
          }
        })

        nodeCopy.querySelectorAll('[style]').forEach(node => {
          if (node.style.fontSize) {
            let fontSizeNumber = sizeMap[node.style.fontSize]
            if (fontSizeNumber) {
              node.innerHTML = `<font num="${fontSizeNumber}">${node.innerHTML}</font>`
              node.style.removeProperty('font-size')
              if (!node.getAttribute('style')) {
                node.removeAttribute('style')
              }
            }
          }
        })
         nodeCopy.querySelectorAll('action').forEach(node => {
          // 处理 link 类的数据提供 pc 客户端使用
          if (node.getAttribute('action-type') === 'link') {
            const newInnerText = node.innerText.split('\uFEFF').join('')
            node.innerHTML = newInnerText
            console.log('node', node)
          }
         })
         nodeCopy.querySelectorAll('[uploadType]').forEach(node => {
          if (node.getAttribute('uploadType') === 'uploadFile') {
            const url = node.getAttribute('url')
            const length = node.getAttribute('length')
            node.style = 'color: rgb(39,130,214)'
            node.innerHTML = `<file url="${url}" size="${length}">${node.innerText}</file>`
            node.removeAttribute('class')
            node.removeAttribute('contenteditable')
            node.removeAttribute('url')
            node.removeAttribute('length')
            node.removeAttribute('uploadType')
            // const fileUrl = node.getAttribute('url')
          }
         })
        return nodeCopy.innerHTML.replace(/\t/g, '    ').replace(/&amp;/gm, '&')
      },
      // 获取处理过的纯文本，将伪类转为了文字
      getNativeText () {
        let text = ''
        let countList = [0, 0, 0, 0, 0, 0, 0, 0, 0]
        let self = this
        function mapNodeChild (node) {
          node.childNodes.forEach((el, index) => {
            if (el.hasChildNodes()) {
              // 过滤图片工具栏
              if (el.className === 'quill-img-resize') {
                return
              }
              if ((el.tagName === 'P' || el.tagName === 'LI' || el.tagName === 'OL' || el.tagName === 'UL') && text !== '' && node.childNodes[index - 1]) {
                text += '\n'
              }

              if (el.tagName === 'LI' && el.parentNode.tagName === 'OL') {
                let level = Number(el.className.replace('ql-indent-', '')) || 0
                let index
                if (level % 3 === 0) {
                  index = Number(countList[level]++) + 1
                }
                if (level % 3 === 1) {
                  index = self.convert26(Number(countList[level]++) + 1)
                }
                if (level % 3 === 2) {
                  index = self.convertRoma(Number(countList[level]++) + 1)
                }
                text += `${index}.`
                countList.splice(level + 1, 9 - (level + 1), ...new Array(9 - (level + 1)).fill(0))
              }
              if (el.tagName === 'LI' && el.parentNode.tagName === 'UL') {
                text += `•`
              }
              mapNodeChild(el)
            } else if ((node.childNodes[index + 1] && node.childNodes[index + 1].tagName === 'SPAN' && node.childNodes[index + 1].getAttribute('contenteditable') === 'false') || (node.childNodes[index - 1] && node.childNodes[index - 1].tagName === 'SPAN' && node.childNodes[index - 1].getAttribute('contenteditable') === 'false')) {
            } else {
              text += el.textContent
            }
          })
        }
        mapNodeChild(this.$refs['kye-editor-new'].querySelector('.ql-editor'))
        return text.replace(/\t/g, '    ')
      },
      // 隐藏所有下拉列
      hideSelect (notNode) {
        this.$refs['kye-editor-new'].querySelectorAll('.select-warp .our-sel-warp').forEach(el => {
          if (notNode !== el) {
            el.className = el.className.replace('show', '')
          }
        })
        this.showCustomColor = false
      },
      getNodeStartOffset (_range) {
        let offset = 0
        let line = this.getSelectRangeLine(_range)
        this.$refs['kye-editor-new'].querySelector('.editor .ql-editor').childNodes.forEach(node => {
          if (node !== line) {
            offset += node.textContent.length
          }
        })
        return offset
      },
      getSelectRangeLine (_range) {
        let range = _range
        while (range.nodeName !== 'DIV' && range.nodeName !== 'P') {
          range = range.parentNode
        }
        return range
      },
      getRange () {
        return window.getSelection()
      },
      // 禁用编辑器
      disabledEditor (val) {
        this.$refs.editor.querySelector('.ql-editor').setAttribute('contenteditable', !val)
        this.$refs.toolbar.style.pointerEvents = val ? 'none' : 'auto'
      },
      // 绑定编辑器聚焦事件
      bindEditorFocus () {
        this.$refs.editor.querySelector('.ql-editor').addEventListener('focus', () => {
          this.$emit('focus')
        })
      },
      // 绑定编辑器失焦事件
      bindEditorBlur () {
        this.$refs.editor.querySelector('.ql-editor').addEventListener('blur', () => {
          this.$emit('blur')
        })
      },
      // 使编辑器失焦
      blur () {
        this.quill.blur()
      },
      // 使编辑器聚焦
      focus () {
        this.quill.focus()
      },
      restoreSelection () {
        let selection = this.getRange()
        selection.removeAllRanges()
        selection.addRange(this.currentRange)
      },
      saveRange (_range) {
        if (_range) {
          this.currentRange = _range
          return
        }
        let selection = this.getRange()
        if (selection.rangeCount === 0) {
          return
        }
        let range = selection.getRangeAt(0)
        this.currentRange = range
      },
      // 接受配置，渲染工具栏
      renderTool () {
        let colorItemList = ''
        let colorConfig = this.tool.find(item => item.key === 'color') && this.tool.find(item => item.key === 'color').value
        colorConfig = colorConfig || colorList
        colorConfig.forEach(item => {
          colorItemList += `
              <button type="button" value="${item}">
                <i style="background-color: ${item}"></i>
              </button>
            `
        })

        let sizeItemList = ``
        let sizeConfig = this.tool.find(item => item.key === 'size') && this.tool.find(item => item.key === 'size').value
        if (!sizeConfig) {
          sizeConfig = FONT_SIZE
        }

        // 原生只接受以下七个字体大小数值，所以关闭调自由配置字体大小的配置
        sizeConfig.forEach(item => {
          sizeItemList += `
              <div class="our-sel-item">
                  <button type="button" value="${item}">${item.replace('px', '')}</button>
                </div>`
        })
        let template = toolsRender(colorItemList, sizeItemList)
        let list = []
        this.tool.forEach(item => {
          if (!list.includes(item.key) || !list.includes(item) || item === 'split') {
            list.push(item.key || item)
          }
        })
        this.toolbarConfigList = []
        list.forEach(item => {
          const option = this.tool.find(v => v.key === item)
          if (template[item]) {
            this.toolbarConfigList.push({
              key: item,
              formatter: template[item]
            })
          } else if (option) {
            this.toolbarConfigList.push({
              key: item,
              formatter: option.formatter
            })
          }
        })
        this.$nextTick(() => {
          this.$refs.toolbar.querySelectorAll('[action-name]').forEach(node => {
            node.addEventListener('mouseenter', event => {
              let actionNameNode = document.createElement('DIV')
              actionNameNode.innerText = event.target.getAttribute('action-name')
              actionNameNode.className = 'action-name'
              event.target.appendChild(actionNameNode)
            })
          })
          this.$refs.toolbar.querySelectorAll('[action-name]').forEach(node => {
            node.addEventListener('mouseleave', event => {
              let actionNameNode = event.target.querySelector('.action-name')
              event.target.removeChild(actionNameNode)
            })
          })
        })
      },
      // 给quill实例添加fontsize 列表
      addFontSize () {
        // 原生只接受以下七个字体大小数值，所以关闭调自由配置字体大小的配置
        let sizeConfig = this.tool.find(item => item.key === 'size') && this.tool.find(item => item.key === 'size').value
        let fontSize = sizeConfig || FONT_SIZE
        this.Quill.imports['attributors/style/size'].whitelist = fontSize
        this.Quill.register(this.Quill.imports['attributors/style/size'])
      },
      addBlot() {
        this.Quill.register(Assign, true)
        this.Quill.register(FileBlot, true)
        this.Quill.register('modules/imageResize', ImageResize)
        this.Quill.register('formats/emoji', EmojiBlot)
        this.Quill.register('formats/superLink', LinkBlot)
      },
      // 处理编辑器里面的表情blot点击有聚焦效果
      initEmojiFocusEvent () {
        this.$refs.editor.addEventListener('click', async (e) => {
          // 处理emoji表情blot
          if (e.target.tagName === 'IMG' && e.target.className === 'emoji') {
            let blot = this.Quill.find(e.target)
            let index = this.quill.getIndex(blot)
            this.quill.setSelection(index, 0)
          }
        })
      },
      // 创建富文本编辑器
      createEditor () {
        let options = {
          modules: {
            toolbar: `[tagId="${this.tagId}"].kye-editor-new .toolbar`,
            imageResize: {
              displaySize: true
            },
          },
          scrollingContainer: this.scrollingContainer,
          placeholder: this.placeholder || ' ',
          theme: 'snow'
        }
        this.quill = new this.Quill(`[tagId="${this.tagId}"].kye-editor-new .editor`, options)
        this.editor = this.$refs.editor
        this.bindEditorFocus()
        this.bindEditorBlur()
        this.disabledEditor(this.disabled)
        this.bindEditorPaste()
        this.defaultValue && this.setContent(this.defaultValue)
      },
      // 给工具栏的下拉列添加点击事件,收起下拉列
      setSelectClick () {
        this.$refs['kye-editor-new'].querySelectorAll('.select-warp .our-btn').forEach(el => {
          el.onclick = event => {
            let node = this.getBtn(event.target)
            let fatherNode = this.findNodeParent(node, 'select-warp').querySelector('.our-sel-warp')
            if (!fatherNode.className.includes('show')) {
              this.hideSelect(fatherNode)
              fatherNode.className += ' show'
            } else {
              this.hideSelect()
            }
          }
        })

        this.$refs['kye-editor-new'].querySelector('.toolbar').addEventListener('click', event => {
          let fatherNode = this.findNodeParent(this.getBtn(event.target), 'select-warp')
          const isTargetClassName = !event.target.className || (Array.isArray(event.target.className) && !event.target.className.includes('zuoduiqi') && !event.target.className.includes('juzhong') && !event.target.className.includes('youduiqi') && !event.target.className.includes('radio') && !event.target.className.includes('tool-icon-xiala'))
          if (this.$refs['kye-editor-new'].querySelector('.sel-hidden.show') && (!fatherNode.className || (!fatherNode.className.includes('align') && !fatherNode.className.includes('size') && isTargetClassName))) {
            this.hideSelect()
          }
        })

        this.editor.addEventListener('click', () => {
          this.hideSelect()
        })
      },
      // 注册图片 matcher，控制是否允许粘贴图片
      registerImageMatcher() {
        const Delta = this.Quill.imports['delta']
        this.quill.clipboard.addMatcher('IMG', (node, delta) => {
          if (!this.canPasteImg) {
            // 返回空 Delta，忽略 img 标签
            return new Delta()
          }
          return delta
        })
      },
      bindEditorPaste() {
        //  自定义粘贴图片功能
        this.quill.root.addEventListener('paste', evt => {
          if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
            evt.preventDefault()
            if (this.canPasteImg) {
              Array.prototype.forEach.call(evt.clipboardData.files, file => {
                  if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
                      return
                  }
                  this.uploadType = 'image'
                  this.accept = ['image']
                  this.upLoadImg(file).then(res => {
                    this.uploadSuccess(res)
                  })
              })
            } else {
              this.dontPasteImgMsg && this.$message.error(this.dontPasteImgMsg)
            }
          }
        }, false)
      },
      /**
       * 图片上传文件中心
       */
      async upLoadImg(file) {
        this.loading = true
        let param = new FormData()
        param.append('bizCode', this.bizCode)
        // param.append('bizId', this.bizId)
        param.append('num', 1)
        param.append('token', getToken())
        param.append('x-uid', this.$store.getters.user.id)
        param.append('file', file)
        try {
          let res = await axios.post('router/upload', param, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          this.loading = false
          return res.data.data
        } catch (e) {
          this.$message.error('图片上传失败')
          this.loading = false
        }
      },
      // 设置最大长度，其中注释部分为，当到达最大长度时，禁止用户输入，已实现，业务需要注释掉了-
      setMaxLength () {
        this.editor.addEventListener('keydown', event => {
          this.upTextCount()
        })
        this.editor.addEventListener('click', event => {
          const node = event.target
          // 判断是否为文件类型，是则点击打开下载
          if (node && node.getAttribute('uploadtype') && node.getAttribute('uploadtype') === 'uploadFile') {
            const url = node.getAttribute('url')
            url && window.open(url)
          }
        })


        this.editor.onkeyup = event => {
          this.upTextCount()
        }

        this.quill.on('text-change', (event) => {
          this.setHistoryLight()
          this.upTextCount()
          // 解决中文输入空格&#xFEFF;光标的问题
          this.removeWhiteSpaces(this.quill.container)
        })

        // 微软
        this.editor.addEventListener('compositionstart', event => {
          this.$refs['kye-editor-new'].querySelector('.ql-editor').classList.remove('ql-blank')
        })
      },
      // 移出空格&#xFEFF;
      removeWhiteSpaces(container) {
        const elements = container.querySelectorAll('.ks-quill-super-link')
        elements.forEach(element => {
          element.innerHTML = element.innerHTML.replace(/\uFEFF/g, '')
        })
      },
      setHistoryLight () {
        let undo = this.$refs['kye-editor-new'].querySelector(`[action="undo"]`)
        let redo = this.$refs['kye-editor-new'].querySelector(`[action="redo"]`)
        if (this.quill.history.stack.redo.length) {
          redo && redo.classList.remove('disabled')
        } else {
          redo && redo.classList.add('disabled')
        }
        if (this.quill.history.stack.undo.length) {
          undo && undo.classList.remove('disabled')
        } else {
          undo && undo.classList.add('disabled')
        }
      },
      // 监听事件处理工具栏高亮
      setCountBtnFormat () {
        this.quill.on('editor-change', (eventName) => {
         this.quill.enable(!this.disabled)
          if (eventName === 'text-change') {
            this.countBtnFormat()
            this.$emit('textChange')
          }
        })
        this.quill.on('selection-change', (range, oldRange, source) => {
          if (this.$el.activeElement && this.$el.activeElement.className.includes('.ql-editor')) {
            this.countBtnFormat()
          }
        })
        this.editor.addEventListener('keydown', event => {
          this.countBtnFormat()
        })
        // this.editor.addEventListener('keydown', event => {
        //   this.countBtnFormat()
        // })
      },
      getActionDom(data) {
        return this.$refs['kye-editor-new'].querySelector(`[action="${data}"]`)
      },
      // 自定义富文本的matcher规则
      setCustomMatcher() {
        // 注册图片过滤 matcher
        this.registerImageMatcher()
        // 艾特人赋值时多添加了属性影响了dom，需要移除
        this.quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
          if (node.className === 'ks-quill-selectUser') {
            delta.ops[0].attributes = null
          }
          return delta
        })
      },
      // 给工具栏按钮添加点击事件
      setClickEvent () {
        let color = this.getActionDom('color')
        let size = this.getActionDom('size')
        let bold = this.getActionDom('bold')
        let italic = this.getActionDom('italic')
        let underline = this.getActionDom('underline')
        let deleteline = this.getActionDom('deleteline')
        let ordered = this.getActionDom('ordered')
        let bullet = this.getActionDom('bullet')
        let indent1 = this.getActionDom('indent1')
        let indent2 = this.getActionDom('indent2')
        let undo = this.getActionDom('undo')
        let redo = this.getActionDom('redo')
        let image = this.getActionDom('image')
        let selectUser = this.getActionDom('selectUser')
        let uploadFile = this.getActionDom('uploadFile')
        let painter = this.getActionDom('painter')
        let link = this.getActionDom('link')
        let background = this.getActionDom('background')
        // 字体颜色面板设置
        this.$refs['kye-editor-new'].querySelectorAll('.color-box .select-warp .our-sel button').forEach(el => {
          el.onclick = event => {
            let node = this.getBtn(event.target)
            this.hideSelect()
            this.quill.format('color', node.value)
            this.$refs['kye-editor-new'].querySelector('[action="color"] .color-icon-line').style.backgroundColor = node.value
            this.$refs['kye-editor-new'].querySelector('[action="color"]').setAttribute('value', node.value)

            this.$refs['kye-editor-new'].querySelectorAll('.color .our-sel i').forEach(el => {
              el.className = ''
            })
            node.querySelector('i').className = 'check'
          }
        })
        // 背景颜色面板设置
        this.$refs['kye-editor-new'].querySelectorAll('.font-bg-box .background-color .our-sel button').forEach(el => {
          el.onclick = event => {
            let node = this.getBtn(event.target)
            this.hideSelect()
            this.quill.format('background', node.value)
            this.$refs['kye-editor-new'].querySelector('[action="background"] .group-icon-line').style.backgroundColor = node.value
            this.$refs['kye-editor-new'].querySelector('[action="background"]').setAttribute('value', node.value)

            this.$refs['kye-editor-new'].querySelectorAll('.background-color .our-sel i').forEach(el => {
              el.className = ''
            })
            node.querySelector('i').className = 'check'
          }
        })

        this.$refs['kye-editor-new'].querySelectorAll('.select-warp.size .our-sel button').forEach(el => {
          el.onclick = event => {
            let node = this.getBtn(event.target)
            this.hideSelect()
            size.querySelector('.font-size').innerHTML = node.innerHTML
            this.quill.format('size', node.value || false)
            this.$refs['kye-editor-new'].querySelector('.size-btn').setAttribute('value', node.value)
            this.$refs['kye-editor-new'].querySelectorAll('.size .our-sel button.selected').forEach(el => {
              el.classList.remove('selected')
            })
            node.classList.add('selected')
          }
        })
        this.$refs['kye-editor-new'].querySelectorAll('.select-warp.align .our-sel button').forEach(el => {
          el.onclick = event => {
            let node = this.getBtn(event.target)
            this.hideSelect()
            this.quill.format('align', node.value)
            this.$refs['kye-editor-new'].querySelector('.align-btn .tool-icon-value').className = node.querySelector('.tool-icon').className + ' tool-icon-value'
            this.$refs['kye-editor-new'].querySelector('.align-btn .tool-icon-value').innerHTML = node.querySelector('.tool-icon').innerHTML
            this.$refs['kye-editor-new'].querySelectorAll('.align .our-sel button.selected').forEach(el => {
              el.classList.remove('selected')
            })
            node.classList.add('selected')
          }
        })

        color && (color.onclick = event => {
          this.quill.format('color', color.value)
        })

        bold && (bold.onclick = event => {
          this.quill.format('bold', !this.quill.getFormat().bold)
          this.countBtnFormat()
        })

        background && (background.onclick = event => {
          this.quill.format('background', background.value)
        })

        italic && (italic.onclick = event => {
          this.quill.format('italic', !this.quill.getFormat().italic)
          this.countBtnFormat()
        })

        underline && (underline.onclick = event => {
          this.quill.format('underline', !this.quill.getFormat().underline)
          this.countBtnFormat()
        })

        deleteline && (deleteline.onclick = event => {
          this.quill.format('strike', !this.quill.getFormat().strike)
          this.countBtnFormat()
        })

        ordered && (ordered.onclick = event => {
          this.quill.format('list', this.quill.getFormat().list ? false : 'ordered')
          this.countBtnFormat()
        })

        bullet && (bullet.onclick = event => {
          this.quill.format('list', this.quill.getFormat().list ? false : 'bullet')
          this.countBtnFormat()
        })

        image && (image.onclick = event => {
          this.uploadType = 'image'
          this.uploadAccept = ['image']
          this.$nextTick(() => {
            this.$refs.upload.manualUpload()
          })
        })

        indent1 && (indent1.onclick = event => {
          if (!indent1.className.includes('disabled')) {
            this.quill.format('indent', '+1')
          }
          this.countBtnFormat()
        })

        indent2 && (indent2.onclick = event => {
          if (!indent2.className.includes('disabled')) {
            this.quill.format('indent', '-1')
          }
          this.countBtnFormat()
        })

        undo && (undo.onclick = () => {
          if (!undo.className.includes('disabled')) {
            this.quill.history.undo()
          }
          this.countBtnFormat()
          this.setHistoryLight()
        })

        redo && (redo.onclick = () => {
          if (!redo.className.includes('disabled')) {
            this.quill.history.redo()
          }
          this.countBtnFormat()
          this.setHistoryLight()
        })

        selectUser && (selectUser.onclick = () => {
          this.userSelectionIndex = this.quill.getSelection() ? this.quill.getSelection().index : 0
          this.showDynamicDialog('searchUser', '添加跨声用户', '300px')
        })

        uploadFile && (uploadFile.onclick = () => {
          this.uploadType = 'uploadFile'
          this.showDynamicDialog('uploadFile', '上传附件', '400px')
        })

        // 格式刷
        painter && (painter.onclick = () => {
          this.painterConfig = {
            value: 'un-active',
            format: {},
            type: true
          }
          copyFormat(this.quill, this.painterConfig, () => {
            this.countBtnFormat()
          })
          this.painterConfig.value = 'active'
          this.countBtnFormat()
        })

        link && (link.onclick = () => {
          this.userSelectionIndex = this.quill.getSelection() ? this.quill.getSelection().index : 0
          this.showDynamicDialog('superLink', '添加链接', '300px')
        })
      },
      // 给工具栏按钮设置默认属性
      setDefaultOptions () {
        // 设置字体默认
        let fontSize = this.defaultFontSize && parseInt(this.defaultFontSize)
        if (fontSize && FONT_SIZE.includes(`${fontSize}px`) && fontSize !== 12) {
          const dom = this.$refs['kye-editor-new']
          const contain = dom.querySelector('.ql-container.ql-snow')
          const size = dom.querySelector(`[action="size"]`)
          fontSize = `${fontSize}px`
          contain.style.fontSize = fontSize
          size && size.setAttribute('value', fontSize)
          size && (size.querySelector('.font-size').innerHTML = parseInt(fontSize))
        }
      },
      setUser(data) {
        if (!data.openId) return
        this.quill.insertEmbed(this.userSelectionIndex, 'selectUser', data)
        this.quill.setSelection(this.userSelectionIndex + 1)
      },
      addLink(data) {
        console.log('link-data', data)
        this.quill.insertEmbed(this.userSelectionIndex, 'superLink', {text: data})
        this.quill.setSelection(this.userSelectionIndex + 1)
      },
      uploadSuccess(files, list) {
        const url = files && files[0].url
        const index = this.quill.getSelection() ? this.quill.getSelection().index : 0
        if (this.uploadType === 'image') {
          if (url) {
            this.quill.insertEmbed(index, 'image', url)
            this.quill.setSelection(index + 1)
            this.countBtnFormat()
          }
        }
      },
      uploadFileHanlder(list) {
        list.map(item => {
          const index = this.quill.getSelection() ? this.quill.getSelection().index : 0
          this.quill.insertEmbed(index, 'uploadFile', item)
          this.quill.setSelection(index + 2)
        })
        this.countBtnFormat()
      },
      updateColor (hex) {
        const dom = this.$refs['kye-editor-new'].querySelector('.select-warp.color .our-sel')
        const total = 8
        const useBtnDom = dom.querySelectorAll('.use-color button')
        let button = document.createElement('button')
        button.value = hex
        button.innerHTML = `<i style="background-color: ${hex}"></i>`
        useBtnDom.length > 0 && useBtnDom.length >= total && useBtnDom[useBtnDom.length - 1].remove()
        dom.querySelector('.use-color').insertBefore(button, useBtnDom[0])
      },
      showDynamicDialog (view, title, width = '1200px') {
        this.dialogOption.show = true
        this.dialogOption.view = view
        this.dialogOption.title = title
        this.dialogOption.width = width
      },
      closeDynamicDialog () {
        this.dialogOption.show = false
        this.dialogOption.view = null
      },
    }
  }
</script>

<style lang="less">
  @import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/public/components/kye-editor-new/index.vue